import { deleteShares } from '../api/cloudShare';
export default async (shareUid, logger) => {
    return deleteShares(`/user/{userId}/shares/${shareUid}`, {}, logger);
};
